import { QUICK_SEARCH_QUERY, QUICK_SEARCH_RECEIVE, QUICK_SEARCH_ACTIVE, QUICK_SEARCH_SELECT_ITEM, QUICK_SEARCH_LOADING } from '../Actions/QuickSearch.action';

const DEFAULT_STATE = { 
    query: '', 
    result: [],
    products: [],
    showAll: null,
    noHit: null,
    active: false,
    loading: false,
    nameSuggestions: [],
    completionSuggestions: []
};

export const quickSearch = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case QUICK_SEARCH_QUERY:
        case QUICK_SEARCH_RECEIVE:
        case QUICK_SEARCH_ACTIVE:
        case QUICK_SEARCH_SELECT_ITEM:
        case QUICK_SEARCH_LOADING:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}